import { Button } from "antd";
import styles from "./Layout.module.css";

const Foot = () => {
    const fullBuildVersion = process.env.REACT_APP_BUILD_VERSION || '';
    const shortBuildVersion = fullBuildVersion.substring(0, 7);
    
    return (
    <div className={styles.wrap}>
      <div className="borderActiveButton">
        <Button
          style={{
            backgroundColor: `var(--white)`,
            color: `var(--primary)`,
            border: "none",
            boxShadow: "none",
            paddingLeft: 0,
          }}
        >
          {(new Date().getFullYear())}<span style={{ fontSize: "12px" }}>&copy;&nbsp;</span>tillit
        </Button>
      </div>
      <div className={styles.rightButtons}>
        <div className="borderActiveButton">
          <Button
            style={{
              backgroundColor: `var(--white)`,
              color: `var(--primary)`,
              border: "none",
              boxShadow: "none",
            }}
          >
            Disclaimer
          </Button>
        </div>
        <div className="borderActiveButton">
          <Button
            style={{
              backgroundColor: `var(--white)`,
              color: `var(--primary)`,
              border: "none",
              boxShadow: "none",
            }}
          >
            Privacy policy
          </Button>
        </div>
        <div className="borderActiveButton" style={{alignItems: `center`}}>
          <div
            style={{
              backgroundColor: `var(--white)`,
              color: `var(--primary)`,
              border: "none",
              boxShadow: "none",
            }}
          >
            v1.7.3 {shortBuildVersion && shortBuildVersion.length != 0 && (
                <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>- {shortBuildVersion}</span>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Foot;
